import styled from 'styled-components';

export const Wrapper = styled.div`
  .avatar {
    border-radius: 50%;
  }
`;

export default Wrapper;
